import handleFormSubmitError from '@/utils/forms/handleFormSubmitError'

interface AntdFormValidationError {
  errorFields: unknown[]
}

const isAntdFormValidationError = (
  error: unknown
): error is AntdFormValidationError =>
  typeof error === 'object' &&
  error !== null &&
  'errorFields' in error &&
  Array.isArray((error as AntdFormValidationError).errorFields)

export const handleStockImportsFormError = (error: unknown) => {
  if (!isAntdFormValidationError(error)) return false

  handleFormSubmitError(false)
  return true
}
